import { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Trash2, X, Save } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const getHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("bct_token")}` });

const emptyForm = { name: "", title: "", text: "" };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);

  const load = () => {
    axios.get(`${API}/api/testimonials`, { headers: getHeaders() }).then((r) => setItems(r.data));
  };

  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(emptyForm); setEditing("new"); };
  const close = () => { setEditing(null); };

  const handleSave = async () => {
    setLoading(true);
    try {
      if (editing === "new") {
        await axios.post(`${API}/api/admin/testimonials`, form, { headers: getHeaders(), withCredentials: true });
      } else {
        await axios.put(`${API}/api/admin/testimonials/${editing.id}`, form, { headers: getHeaders(), withCredentials: true });
      }
      close();
      load();
    } catch { alert("Hata oluştu"); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bu görüşü silmek istediğinize emin misiniz?")) return;
    await axios.delete(`${API}/api/admin/testimonials/${id}`, { headers: getHeaders(), withCredentials: true });
    load();
  };

  return (
    <div data-testid="admin-testimonials">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "Outfit" }}>Müşteri Görüşleri</h1>
        <button onClick={openNew} className="flex items-center gap-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors" data-testid="add-testimonial-btn">
          <Plus size={16} /> Yeni Görüş
        </button>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {items.map((t) => (
          <div key={t.id} className="bg-[#161923] border border-white/5 rounded-xl p-5" data-testid={`testimonial-${t.id}`}>
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#FF5A00]/20 flex items-center justify-center text-[#FF5A00] font-bold text-sm">
                  {t.name[0]}
                </div>
                <div>
                  <p className="text-white font-medium text-sm">{t.name}</p>
                  <p className="text-slate-500 text-xs">{t.title}</p>
                </div>
              </div>
              <button onClick={() => handleDelete(t.id)} className="p-2 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors" data-testid={`delete-testimonial-${t.id}`}>
                <Trash2 size={14} />
              </button>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">{t.text}</p>
          </div>
        ))}
        {items.length === 0 && (
          <div className="col-span-full text-center py-12 text-slate-500">Henüz görüş eklenmedi</div>
        )}
      </div>

      {/* Modal */}
      {editing !== null && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" data-testid="testimonial-modal">
          <div className="bg-[#1a1d27] border border-white/10 rounded-2xl w-full max-w-lg">
            <div className="flex items-center justify-between p-5 border-b border-white/5">
              <h2 className="text-lg font-bold text-white" style={{ fontFamily: "Outfit" }}>Yeni Müşteri Görüşü</h2>
              <button onClick={close} className="text-slate-400 hover:text-white"><X size={20} /></button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Ad Soyad</label>
                <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="admin-input" data-testid="form-testimonial-name" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Ünvan</label>
                <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="admin-input" data-testid="form-testimonial-title" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Görüş Metni</label>
                <textarea value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} rows={4} className="admin-input resize-none" data-testid="form-testimonial-text" />
              </div>
            </div>
            <div className="flex justify-end gap-3 p-5 border-t border-white/5">
              <button onClick={close} className="px-4 py-2 rounded-lg text-sm text-slate-400 hover:text-white border border-white/10 transition-colors">İptal</button>
              <button onClick={handleSave} disabled={loading || !form.name || !form.text} className="flex items-center gap-2 px-4 py-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white rounded-lg text-sm font-semibold transition-colors disabled:opacity-50" data-testid="form-testimonial-save">
                <Save size={14} /> {loading ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
